export default __webpack_public_path__ + "static/economy-b15367ea4c5023e75a221593bee4f9b4.png";